import AmexExperientialHeader from './AmexExperientialHeader';

export default AmexExperientialHeader;
